import * as types from './weaveActionTypes';

const initialState = {
  weaveData: null,
  weaveList: [],
  createWeaveData: null,
  createWeaveError: null,
  updateWeaveData: null,
  updateWeaveError: null,
  deleteWeaveData: null,
  deleteWeaveError: null,
};

export const weaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WEAVE_DATA:
      return {
        ...state,
        weaveData: action.payload || null,
        weaveList: action.payload?.WeaveList || action.payload?.Weaves || [],
      };
    case types.GET_WEAVE_ERROR:
      return {
        ...state,
        weaveData: null,
        weaveList: [],
      };
    case types.CREATE_WEAVE_DATA:
      return {
        ...state,
        createWeaveData: action.payload,
        createWeaveError: null,
      };
    case types.CREATE_WEAVE_ERROR:
      return {
        ...state,
        createWeaveData: null,
        createWeaveError: action.payload,
      };
    case types.UPDATE_WEAVE_DATA:
      return {
        ...state,
        updateWeaveData: action.payload,
        updateWeaveError: null,
      };
    case types.UPDATE_WEAVE_ERROR:
      return {
        ...state,
        updateWeaveData: null,
        updateWeaveError: action.payload,
      };
    case types.DELETE_WEAVE_DATA:
      return {
        ...state,
        deleteWeaveData: action.payload,
        deleteWeaveError: null,
      };
    case types.DELETE_WEAVE_ERROR:
      return {
        ...state,
        deleteWeaveData: null,
        deleteWeaveError: action.payload,
      };
    default:
      return state;
  }
};
